<template>
    <div
        class="
        d-flex
        flex-column
        align-items-center
        setMaxWidthOfChildren
    "
    >
        <h4>{{ $t('activateuser.step2.header') }}</h4>
        <p>
            {{ $t('activateuser.step2.description') }}
        </p>

        <form @submit.prevent="handleNextPage">
            <TextField
                class="my-4"
                :placeholder="$t('general.email')"
                type="email"
                :value="value.email"
                required
                @input="onChange('email', ...arguments)"
                padding
                :helperText="emailHelperText"
                :stateEnum="validEmail ? 0 : 2"
            />
            <template>
                <div>
                    {{ $t('activateuser.step2.passwordDescription01') }}
                </div>
                <br />
                <div class="d-flex flex-align-center">
                    <p
                        class="flex-grow"
                        :style="
                            `${
                                minEightChars
                                    ? 'color: var(--success)'
                                    : 'color: var(--error)'
                            } !important;`
                        "
                    >
                        {{ $t('activateuser.step2.passwordDescription02') }}
                    </p>
                    <BaseIcon
                        v-if="showMinEightCharsError"
                        name="exclamation-circle"
                        size="lg"
                        style="color: var(--error);"
                    />
                </div>
                <div class="d-flex flex-align-center">
                    <p
                        class="flex-grow"
                        :style="
                            `${
                                oneLowerCase
                                    ? 'color: var(--success)'
                                    : 'color: var(--error)'
                            } !important;`
                        "
                    >
                        {{ $t('activateuser.step2.passwordDescription03') }}
                    </p>
                    <BaseIcon
                        v-if="showOneLowerCaseError"
                        name="exclamation-circle"
                        size="m"
                        style="color: var(--error);"
                    />
                </div>
                <div class="d-flex flex-align-center">
                    <p
                        class="flex-grow"
                        :style="
                            `${
                                oneUpperCase
                                    ? 'color: var(--success)'
                                    : 'color: var(--error)'
                            } !important;`
                        "
                    >
                        {{ $t('activateuser.step2.passwordDescription04') }}
                    </p>
                    <BaseIcon
                        v-if="showOneUpperCaseError"
                        name="exclamation-circle"
                        size="m"
                        style="color: var(--error);"
                    />
                </div>
                <!-- <p class="list-item">
                    {{ $t('activateuser.step2.passwordDescription05') }}
                </p> -->

                <div class="d-flex flex-align-center">
                    <p
                        class="flex-grow"
                        :style="
                            `${
                                passwordMatch
                                    ? 'color: var(--success)'
                                    : 'color: var(--error)'
                            } !important`
                        "
                    >
                        {{ $t('activateuser.step2.passwordsNotMatch') }}
                    </p>
                    <BaseIcon
                        v-if="showNoMatchErrorIcon"
                        name="exclamation-circle"
                        size="m"
                        style="color: var(--error)"
                    />
                </div>

                <TextField
                    class="mt-4 mb-2"
                    :placeholder="$t('general.password')"
                    type="password"
                    :value="value.password"
                    @input="onChange('password', ...arguments)"
                    padding
                    required
                    :stateEnum="validPassword ? 0 : 2"
                />
                <TextField
                    class="mb-4"
                    :placeholder="$t('activateuser.step2.repeatPassword')"
                    type="password"
                    v-model="confirmedPassword"
                    padding
                    required
                    :stateEnum="passwordMatch && validPassword ? 0 : 2"
                />
            </template>
            <div class="d-flex mb-4" style="justify-items: stretch">
                <BaseButton
                    @click="handlePrevPage"
                    class="outlined mx-3"
                    style="flex-basis: 0; flex-grow: 1"
                >
                    {{ $t('general.back') }}
                </BaseButton>
                <BaseButton
                    variant="primary"
                    type="submit"
                    class="mx-3"
                    style="flex-basis: 0; flex-grow: 1"
                >
                    {{ $t('general.next') }}
                </BaseButton>
            </div>
        </form>
    </div>
</template>

<script>
// Utils
import { emailValidator } from '~/utils/validators';

export default {
    name: 'Step2',

    props: {
        value: {
            type: Object,
            default: () => ({}),
        },
        activateUser: Function, // Function to activate the user
    },

    data: () => ({
        confirmedPassword: '',
        showMinEightCharsError: false,
        showOneUpperCaseError: false,
        showOneLowerCaseError: false,
        showNoMatchErrorIcon: false,
    }),

    computed: {
        passwordMatch() {
            if (
                this.value.password === this.confirmedPassword &&
                this.confirmedPassword.length > 0
            ) {
                this.showNoMatchErrorIcon = false;
                return true;
            }
            return false;
        },
        minEightChars() {
            if (this.value.password.length >= 8) {
                this.showMinEightCharsError = false;
                return true;
            }
            return false;
        },
        oneUpperCase() {
            if (this.value.password.match(/[A-Z]/) !== null) {
                this.showOneUpperCaseError = false;
                return true;
            }
            return false;
        },
        oneLowerCase() {
            if (this.value.password.match(/[a-z]/) !== null) {
                this.showOneLowerCaseError = false;
                return true;
            }
            return false;
        },
        validEmail() {
            const email = this.value.email || '';
            return emailValidator(email);
        },
        validPassword() {
            return this.minEightChars && this.oneLowerCase && this.oneUpperCase;
        },
        emailHelperText() {
            return (this.value.email || '').length > 3 && !this.validEmail
                ? this.$t('activateuser.step2.invalidEmail')
                : '';
        },
    },

    methods: {
        onChange(type, value) {
            const credentials = Object.assign({}, this.value);
            credentials[type] = value;
            this.$emit('input', credentials);
        },
        handlePrevPage() {
            const credentials = Object.assign({}, this.value);
            credentials.email = '';
            credentials.password = '';
            this.confirmedPassword = '';
            this.$emit('input', credentials);
            this.$emit('prevpage');
        },
        handleNextPage() {
            if (
                this.minEightChars &&
                this.oneUpperCase &&
                this.oneLowerCase &&
                this.passwordMatch
            ) {
                if (this.activateUser) {
                    this.activateUser();
                }
                this.$emit('nextpage');
            } else {
                if (!this.minEightChars) this.showMinEightCharsError = true;
                if (!this.oneUpperCase) this.showOneUpperCaseError = true;
                if (!this.oneLowerCase) this.showOneLowerCaseError = true;
                if (!this.passwordMatch) this.showNoMatchErrorIcon = true;
            }
        },
    },
};
</script>
